export const getAppliedFilterData = (counterPartyData, zoneList, riskLevel, reportType, riskTrend, legalConstitution, busniessSegment, caseStatus, caseType, productTypes) => {
    return {
        counterpartyType: counterPartyData,
        region: zoneList,
        riskLevel: riskLevel,
        reportType: reportType,
        riskTrend: riskTrend,
        classOfCompany: legalConstitution,
        businessSegment: busniessSegment,
        caseStatus: caseStatus,
        caseType: caseType,
        productTypes : productTypes
    }
}
export const validateDatefilter = (toDate, fromDate) => {
    if (!toDate && !fromDate) {
        return true
    } else if (toDate && fromDate) {
        return true
    } else {
        return false
    }
}

export const setMultiSelectData = (data) => {
    let tempData = [];
    data.forEach((item) => {
        tempData.push({ label: item.value, value: item.id })
    })
    return tempData;
}